// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__1DCOX","header":"PatientBlock_header__3mvu6","label":"PatientBlock_label__3LPSD","option":"PatientBlock_option__1t2Ch"};